/**
 * PolygonCell Component
 * 
 * Renders Parse Polygon values with:
 * - Point count display: "Polygon (5 points)"
 * - Click to expand and see all coordinates
 */

import { CellRendererProps, ParsePolygon } from '../../../../../types/AppPanel';

export default function PolygonCell({ 
  value, 
  onExpand 
}: CellRendererProps<ParsePolygon | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }

  // Validate Polygon structure
  if (typeof value !== 'object' || !Array.isArray(value.coordinates)) {
    return <span className="text-white/30 italic">(invalid polygon)</span>;
  }

  const pointCount = value.coordinates.length;

  return (
    <button
      onClick={onExpand}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full 
                 bg-teal-500/20 text-teal-400 text-xs font-medium
                 hover:bg-teal-500/30 transition-colors cursor-pointer"
      title={`Polygon with ${pointCount} vertices`}
    >
      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
      </svg>
      Polygon ({pointCount} pts)
    </button>
  );
}

